import React, { Component, PropTypes } from 'react';
import { Units } from 'Css';
import classNames from 'classnames';

const css = oxygenCss({
  root: {
    padding: Units.base,
    boxSizing: 'border-box',
    ' A': {
      color: 'inherit !important',
      textDecoration: 'underline'
    },
    '&size1': {
      minHeight: Units.keyline * 2
    },
    '&size2': {
      minHeight: Units.keyline * 4
    },
    '&size3': {
      minHeight: Units.keyline * 6
    }
  }
});

class StoreTextModule extends Component {
  static propTypes = {
    color: PropTypes.string,
    backgroundColor: PropTypes.string,
    size: PropTypes.number,
    __html: PropTypes.string
  };

  render() {
    const { __html, color, backgroundColor, size } = this.props;
    const classes = classNames(css.root, {
      [css[`size${size}`]]: size
    });
    return (
      <div
        className={classes}
        style={{ color, backgroundColor }}
        dangerouslySetInnerHTML={{ __html }}
      />
    );
  }
}

export default StoreTextModule;



// WEBPACK FOOTER //
// ./src/js/components/Store/Modules/StoreTextModule.js